export interface SparkPaths {
  /** SVG path for the trace itself */
  line: string;
  /** The trace closed along the floor, for a fill underneath */
  area: string;
}

const fmt = (n: number): string => String(Math.round(n * 10) / 10);

/**
 * Sparkline paths for a series, scaled so the peak touches the ceiling.
 * `pad` keeps the stroke inside the box. Values are message counts, so the
 * floor is always zero.
 */
export const sparkPath = (values: number[], width: number, height: number, pad = 1): SparkPaths => {
  if (values.length === 0) return { line: '', area: '' };
  const points = values.length === 1 ? [values[0], values[0]] : values;
  const max = Math.max(1, ...points);
  const inner = height - 2 * pad;
  const step = width / (points.length - 1);
  const coords = points.map((v, i) => `${fmt(i * step)},${fmt(pad + (1 - v / max) * inner)}`);
  const line = `M${coords[0]} L${coords.slice(1).join(' L')}`;
  const floor = fmt(height - pad);
  const area = `${line} L${fmt(width)},${floor} L0,${floor} Z`;
  return { line, area };
};
